import { createStore } from '@cobuildlab/react-simple-state';
import { CreatePairDialogStore, DeletePairDialogStore } from './pair-types';


export const createPairDialogStore = createStore<CreatePairDialogStore>({
  initialValue: {
    open: false,
  },
});


export const deletePairDialogStore = createStore<DeletePairDialogStore>({
  initialValue: {
    open: false,
  },
});